import EditBase from "./EditBase"

//https://cesium.com/learn/cesiumjs/ref-doc/PointGraphics.html#.ConstructorOptions
class EditPoint extends EditBase {
    constructor(options) {
        super(options);
        this.styleOrig = undefined;
        this.styleEdit = {
            color: Cesium.Color.RED,
            outlineColor: Cesium.Color.YELLOW,
            outlineWidth: 4
        };

    }
    mouseMove(evt) {
        let pick = this.viewer.scene.pick(evt.endPosition);
        var entity = this.getPickEnity(pick);
        if (this.styleOrig) {
            this.setStyle(this.plot.point, this.styleOrig);
        }
        if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
            this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
            if (!this.styleOrig) {
                this.styleOrig = this.getStyle(entity.point, this.styleEdit);
            }
            this.setStyle(entity.point, this.styleEdit);
        }
        if (this.pick) {
            this.setStyle(this.pick.point, this.styleEdit);
            var cartesian = this.getCatesian3FromPX(evt.endPosition);
            this.pick.position.setValue(cartesian);
        }
    }
    leftDown(evt) {
        if (this.styleOrig) {
            this.setStyle(this.plot.point, this.styleOrig);
        }

        let pick = this.viewer.scene.pick(evt.position);
        var entity = this.getPickEnity(pick);
        if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
            this.pick = entity;
            this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
            this.callback && this.callback(this.pick);
        }
    }

    leftUp(evt) {
        this.pick = null;
        this.viewer.scene.screenSpaceCameraController.enableRotate = true;//解锁相机
    }
}

export default EditPoint;